import { NewsRibbonProvider } from '@/context/NewsRibbon';
import { withMetadata } from '@/features/SEO/withMetadata';
import { SSO_ROOT } from '@/utils/constants';
import { BrComponent, BrPageContext } from '@bloomreach/react-sdk';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { useContext, useMemo } from 'react';
import { Route } from 'react-router-dom';

const useStyles = makeStyles(
  ({ zIndex }) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      },
      main: {
        flexGrow: 1,
      },
      sticky: {
        position: 'sticky',
        top: 0,
        zIndex: zIndex.appBar,
      },
      noHeight: {
        height: 0,
      },
    }),
  { name: 'SingleColumn' },
);

const Main = () => {
  return (
    <div className="main">
      <BrComponent path="breadcrumb" />
      <BrComponent path="dropzone-shared" />
      <BrComponent path="dropzone1" />
      <BrComponent path="dropzone2" />
      <BrComponent path="dropzone3" />
      <BrComponent path="dropzone4" />
      <BrComponent path="content" />
      <BrComponent path="account" />
    </div>
  );
};

const SingleColumn = () => {
  const classes = useStyles();
  const page = useContext(BrPageContext);
  const pageTemplate = useMemo(() => page?.getComponent()?.getParameters()?.template ?? '', [page]);
  const isPreview = useMemo(() => page?.isPreview(), [page]);
  const isTransparent = useMemo(
    () => !isPreview && /single-column-transparent-nav/.test(pageTemplate),
    [isPreview, pageTemplate],
  );
  const headerClass = clsx(!isPreview && classes.sticky, isTransparent && classes.noHeight);
  // ".main" class needed for crawling
  const mainClass = clsx(classes.main, 'main');

  return (
    <div className={classes.root}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <BrComponent path="header">
        <NewsRibbonProvider>
          <BrComponent path="news-ribbon-container" />

          <header className={headerClass}>
            <BrComponent path="menu" />
          </header>
        </NewsRibbonProvider>
      </BrComponent>

      <Route path={SSO_ROOT}>
        <BrComponent path="portalmenu" />
      </Route>

      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <BrComponent path="main">
        <div className={mainClass}>
          <Main />
        </div>
      </BrComponent>

      <footer>
        <BrComponent path="metadata" />
        <BrComponent path="footer" />
      </footer>
    </div>
  );
};

export default withMetadata(SingleColumn);
